import { ZeroHero } from "@ecologi/react-components/src";

type Props = {
  data: {
    title: string;
    subtitle: string;
    call_to_action_text: string;
    call_to_action_link: string;
  };
};

export default (props: Props) => {
  return <ZeroHero {...props.data} />;
};
